export const iconFontAwesomeDevicesHardwareMobileRetro = (
	<i className="fa-solid fa-mobile-retro"></i>
);
